<template>
    <div>
        <div v-if="!mult">
            <div class="alert alert-info d-print-none" v-if="info && !id_medico_repasse && !resumo_pagamento">
                <div class="d-flex justify-content-between">
                    <div>
                        <span v-if="info.geral">Geral</span>
                        <span v-else>{{ info.medico ? info.medico.search : '' }}</span>
                    </div>
                    <div v-if="info.parms && info.parms.origem == 'P'">
                        Produção
                    </div>
                    <div v-if="info.parms" class="text-right">
                        {{ $util.getFormatDate(info.parms.inicio) }} a {{ $util.getFormatDate(info.parms.fim) }}
                        <div v-if="info.parms.filtra_hora" class="small text-muted">
                            {{ info.parms.hor_inicio }} às {{ info.parms.hor_fim }}
                        </div>
                    </div>
                </div>
                <template v-if="apuro.filtros && apuro.filtros.length">
                    <hr>
                    <div v-for="(filtro, ifx) in apuro.filtros" :key="ifx">
                        <span v-if="filtro.model">
                            <i class="fa fa-plus-circle fa-fw mr-2" aria-hidden="true" v-if="filtro.fl_regra"></i>
                            <i class="fa fa-minus-circle fa-fw mr-2" aria-hidden="true" v-else></i>
                            {{ titulo_model(filtro) }}
                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                            {{ filtro.model.search }}
                        </span>
                    </div>
                </template>
            </div>

            <template v-if="apuracao && apuracao.length">

                <div class="form-row mb-3">
                    <div class="col col-12 col-md-1 d-flex flex-column" v-if="false && !simulacao">
                        <div class="dropdown" v-if="!resumo_pagamento">
                            <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                                <i class="fa fa-search" aria-hidden="true" v-if="funcao_pesq == 'F'"></i>
                                <i class="fa-solid fa-square-check" aria-hidden="true" v-else-if="funcao_pesq == 'L'"></i>
                            </button>
                            <div class="dropdown-menu">
                                <a class="dropdown-item" href="#" @click.prevent="funcao_pesq = 'F'">
                                    <i class="fa fa-search fa-fw mr-2" aria-hidden="true"></i>
                                    Filtrar
                                </a>
                                <a class="dropdown-item" href="#" @click.prevent="funcao_pesq = 'L'">
                                    <i class="fa-solid fa-square-check fa-fw mr-2"></i>
                                    Leitura para Seleção
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col col-12" :class="info.parms.exibir_repassado && info.parms.exibir_saldo_a_receber ? 'col-md-9' : ''">
                        <template v-if="funcao_pesq == 'L'">
                            <az-input   
                                sizing="sm"
                                placeholder="Informe o número do atendimento..."
                                v-model="search_selecao"
                                @onEnter="selecionar_atend">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend dropdown">
                                        <div class="btn-group" role="group" aria-label="Basic example">
                                            <button type="button" class="btn btn-sm btn-outline-secondary" @click.prevent="funcao_pesq = 'F'"><i class="fa fa-search" aria-hidden="true"></i></button>
                                            <button type="button" class="btn btn-sm btn-secondary" @click.prevent="funcao_pesq = 'L'"><i class="fa-solid fa-square-check"></i></button>
                                        </div>
                                    </div>
                                </template>
                            </az-input>
                        </template>
                        <template v-else>
                            <az-input   
                                sizing="sm"
                                placeholder="Pesquisar..."
                                v-if="!resumo_pagamento"
                                v-model="search_apuracao">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend" id="drop-pesq">
                                        <div class="btn-group" role="group" aria-label="Basic example">
                                            <button type="button" class="btn btn-sm btn-secondary" @click.prevent="funcao_pesq = 'F'"><i class="fa fa-search" aria-hidden="true"></i></button>
                                            <button type="button" class="btn btn-sm btn-outline-secondary" @click.prevent="funcao_pesq = 'L'"><i class="fa-solid fa-square-check"></i></button>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:buttonposb>
                                    <div class="input-group-append" v-if="!simulacao">
                                        <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="selecionar_apuracao()">
                                            <i class="fas fa-sync-alt"></i>
                                        </button>
                                    </div>

                                    <div class="input-group-append" v-else-if="tipo_quebra != 'N' || ( info && info.geral )">
                                        <button type="button" class="btn btn-sm btn-outline-secondary" @click="expandido = !expandido">
                                            <i class="fas fa-expand-arrows-alt fa-fw" v-if="!expandido"></i>
                                            <i class="fas fa-compress-arrows-alt fa-fw" v-else></i>
                                        </button>
                                    </div>

                                    <div class="input-group-append" v-else-if="id_rateio_troca">
                                        <button type="button" class="btn btn-sm btn-outline-secondary" @click="exibe_selecao = !exibe_selecao">
                                            <i class="fa-solid fa-square-check"></i>
                                        </button>

                                        <button type="button" class="btn btn-sm btn-outline-secondary" @click="abrir_selecao_n_proc()" v-if="exibe_selecao">
                                            <i class="fa-solid fa-list-check"></i>
                                        </button>

                                        <button type="button" class="btn btn-sm btn-outline-success" @click="alterar_rateio_medico()" v-if="exibe_selecao">
                                            <i class="fa-solid fa-arrow-right-arrow-left"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </template>
                    </div>

                    <div class="col col-12 col-md-3" v-if="info.parms.exibir_repassado && info.parms.exibir_saldo_a_receber">
                        <az-input
                            icon="fa fa-filter"
                            sizing="sm"
                            type="select"
                            :optionsList="[
                                { id: 'T', search: 'Todos...' },
                                { id: 'S', search: 'Com Saldo' },
                                { id: 'N', search: 'Sem Saldo' },
                            ]"
                            optionsData="id"
                            v-model="filtro_repassado" />
                    </div>
                </div>

                <div class="row mb-3" v-if="simulacao && !resumo_pagamento">
                    <div class="col col-12">
                        <az-input 
                            type="button-group"
                            sizing="sm"
                            :optionsList="lista_quebras"
                            optionsData="id"
                            v-model="tipo_quebra" />
                    </div>
                </div>

                <div id="impressao">

                    <cabecalho-generico titulo="Apuração de Repasse" :show_emissor="true">
                        <div>{{ info.medico ? info.medico.search : '' }}</div>
                        <div v-if="info.parms">
                            {{ $util.getFormatDate(info.parms.inicio) }} a {{ $util.getFormatDate(info.parms.fim) }}
                        </div>
                        <div v-if="origem == 'P'">
                            Produção
                        </div>
                        <template v-if="apuro.filtros && apuro.filtros.length">
                            <hr>
                            <div v-for="(filtro, ifx) in apuro.filtros" :key="ifx">
                                <span v-if="filtro.model">
                                    <i class="fa fa-plus-circle fa-fw mr-2" aria-hidden="true" v-if="filtro.fl_regra"></i>
                                    <i class="fa fa-minus-circle fa-fw mr-2" aria-hidden="true" v-else></i>
                                    {{ titulo_model(filtro) }}
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    {{ filtro.model.search }}
                                </span>
                            </div>
                        </template>
                    </cabecalho-generico>

                    <table class="table table-sm table-hover bg-white small cabecalho-fixo">
                        <thead>
                            <tr>
                                <th>{{ exibir_expandido ? '#' : '' }}</th>
                                <th>{{ exibir_expandido ? 'Data' : '' }}</th>
                                <th>{{ exibir_expandido ? 'Ref.' : '' }}</th>
                                <th>{{ exibir_expandido ? 'Paciente' : '' }}</th>
                                <th>{{ exibir_expandido ? 'Procedimento' : '' }}</th>
                                <th>{{ exibir_expandido ? 'Regra' : '' }}</th>
                                <th class="text-right" v-if="info && info.parms && info.parms.campos_exibir != 'R'">{{ ( exibir_expandido || ( info.geral && info.parms.origem == 'P' ) ) ? 'Produzido' : '' }}</th>
                                <th class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">Recebido</th>
                                <th class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">Glosa/Desc</th>
                                <th class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">Valor</th>
                                <th class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">Retenção</th>
                                <th class="text-right">Repasse</th>
                                <th class="text-right" v-if="info.parms && info.parms.exibir_valor_clinica">Clínica</th>
                                <template v-if="info.parms.exibir_repassado && info.parms.exibir_saldo_a_receber">
                                    <th class="text-right">Repassado</th>
                                    <th class="text-right">Saldo</th>
                                </template>
                                <th class="text-center" v-if="id_medico_repasse">
                                    <input type="checkbox" v-model="todos_marcacao">
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="table-primary">
                                <th colspan="3">
                                    <span class="badge badge-light ml-3">
                                        {{ lista_apuracao.length }}
                                    </span>
                                </th>
                                <th>Total</th>
                                <th colspan="2"></th>
                                <th class="text-right" v-if="info && info.parms && info.parms.campos_exibir != 'R'">
                                    <span v-if="info.geral && info.parms.origem == 'P'">
                                        {{ $util.formatMoeda(totalGeral(lista_apuracao, 'cd_valor_total', false, 'id_atendimento_procedimento')) }}
                                    </span>
                                </th>
                                <th class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">
                                    {{ $util.formatMoeda(totalGeral(lista_apuracao, 'valor_recebido') + totalGeral(lista_apuracao, 'vl_rec_consumo')) }}
                                </th>
                                <th class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">
                                    {{ $util.formatMoeda(totalGeral(lista_apuracao, 'valor_glosa') + totalGeral(lista_apuracao, 'vl_glo_consumo')) }}
                                    <div v-if="( totalGeral(lista_apuracao, 'taxa_cartao') + totalGeral(lista_apuracao, 'taxa_cartao_consumo') ) > 0">
                                        <span class="small text-muted">(Tx) {{ $util.formatMoeda(totalGeral(lista_apuracao, 'taxa_cartao') + totalGeral(lista_apuracao, 'taxa_cartao_consumo')) }}</span>
                                    </div>
                                    <div v-if="totalGeral(lista_apuracao, 'valor_filme') > 0">
                                        <span class="small text-muted">(F) {{ $util.formatMoeda(totalGeral(lista_apuracao, 'valor_filme')) }}</span>
                                    </div>
                                    <div v-if="totalGeral(lista_apuracao, 'valor_co') > 0">
                                        <span class="small text-muted">(UCO) {{ $util.formatMoeda(totalGeral(lista_apuracao, 'valor_co')) }}</span>
                                    </div>
                                </th>
                                <th class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">
                                    {{ $util.formatMoeda(totalGeral(lista_apuracao, 'valor_base') + totalGeral(lista_apuracao, 'total_consumo')) }}
                                </th>
                                <th class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">
                                    {{ $util.formatMoeda(totalGeral(lista_apuracao, 'valor_retencao') + totalGeral(lista_apuracao, 'valor_retencao_consumo')) }}
                                    <div class="small text-muted" v-if="( totalGeral(lista_apuracao, 'valor_cartao_pos') + totalGeral(lista_apuracao, 'valor_cartao_pos_consumo') ) > 0">
                                        TC: {{ $util.formatMoeda(totalGeral(lista_apuracao, 'valor_cartao_pos') + totalGeral(lista_apuracao, 'valor_cartao_pos_consumo')) }}
                                    </div>
                                </th>
                                <th class="text-right">
                                    {{ $util.formatMoeda(totalGeral(lista_apuracao, 'valor_base_rateio') + totalGeral(lista_apuracao, 'rateio_consumo')) }}
                                </th>
                                <th class="text-right" v-if="info.parms && info.parms.exibir_valor_clinica">
                                    {{ 
                                        $util.formatMoeda(
                                            totalGeral(lista_apuracao, 'valor_clinica')
                                            + totalGeral(lista_apuracao, 'clinica_consumo')
                                        ) 
                                    }}
                                </th>
                                <!-- Exibir Valor Repassado e Saldo -->
                                <template v-if="info.parms.exibir_repassado && info.parms.exibir_saldo_a_receber">
                                    <th class="text-right">{{ $util.formatMoeda(totalGeral(lista_apuracao, 'repassado')) }}</th>
                                    <th class="text-right">{{ $util.formatMoeda(totalGeral(lista_apuracao, 'valor_saldo_a_receber')) }}</th>
                                </template>
                                <th v-if="id_medico_repasse"></th>
                            </tr>
                            <tr class="table-info" v-if="id_medico_repasse">
                                <th colspan="3">
                                    <span class="badge badge-light ml-3">
                                        {{ selecionados.length }}
                                    </span>
                                </th>
                                <th>
                                    Selecionado
                                </th>
                                <th colspan="2"></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th class="text-right">
                                    {{ $util.formatMoeda(totalGeral(selecionados, 'valor_base', true) + totalGeral(selecionados, 'total_consumo', true)) }}
                                </th>
                                <th></th>
                                <th class="text-right">
                                    {{ $util.formatMoeda(totalGeral(selecionados, 'valor_base_rateio', true) + totalGeral(selecionados, 'rateio_consumo', true)) }}
                                </th>
                                <th class="text-right" v-if="info.parms && info.parms.exibir_valor_clinica">
                                    {{ 
                                        $util.formatMoeda(
                                            totalGeral(selecionados, 'valor_clinica') 
                                            + totalGeral(selecionados, 'clinica_consumo', true)
                                        ) 
                                    }}
                                </th>
                                <th v-if="id_medico_repasse"></th>
                            </tr>
                            <template v-for="(lista, grupo, igx) in lista_agrupada">
                                <tr class="table-secondary" :key="igx" v-if="tipo_quebra != 'N' || ( info && info.geral )">
                                    <th colspan="3">
                                        <span class="badge badge-light ml-3">
                                            {{ lista.length }}
                                        </span>
                                    </th>
                                    <th colspan="3">
                                        {{ grupo }}
                                    </th>
                                    <th class="text-right" v-if="info && info.parms && info.parms.campos_exibir != 'R'">
                                        <span v-if="info.geral && info.parms.origem == 'P'">
                                            {{ $util.formatMoeda(totalGeral(lista, 'cd_valor_total', false, 'id_atendimento_procedimento')) }}
                                        </span>
                                    </th>
                                    <th class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">
                                        {{ $util.formatMoeda(totalGeral(lista, 'valor_recebido')) }}
                                    </th>
                                    <th class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">
                                        {{ $util.formatMoeda(totalGeral(lista, 'valor_glosa')) }}
                                        <div v-if="( totalGeral(lista, 'taxa_cartao') + totalGeral(lista, 'taxa_cartao_consumo') ) > 0">
                                            <span class="small text-muted">(Tx) {{ $util.formatMoeda(totalGeral(lista, 'taxa_cartao') + totalGeral(lista, 'taxa_cartao_consumo')) }}</span>
                                        </div>
                                        <div v-if="totalGeral(lista, 'valor_filme') > 0">
                                            <span class="small text-muted">(F) {{ $util.formatMoeda(totalGeral(lista, 'valor_filme')) }}</span>
                                        </div>
                                        <div v-if="totalGeral(lista, 'valor_co') > 0">
                                            <span class="small text-muted">(UCO) {{ $util.formatMoeda(totalGeral(lista, 'valor_co')) }}</span>
                                        </div>
                                    </th>
                                    <th class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">
                                        {{ $util.formatMoeda(totalGeral(lista, 'valor_base') + totalGeral(lista, 'total_consumo')) }}
                                    </th>
                                    <th class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">
                                        {{ $util.formatMoeda(totalGeral(lista, 'valor_retencao')) }}
                                        <div class="small text-muted" v-if="totalGeral(lista, 'valor_cartao_pos') > 0">
                                            TC: {{ $util.formatMoeda(totalGeral(lista, 'valor_cartao_pos')) }}
                                        </div>
                                    </th>
                                    <th class="text-right">
                                        {{ $util.formatMoeda(totalGeral(lista, 'valor_base_rateio') + totalGeral(lista, 'rateio_consumo')) }}
                                    </th>
                                    <th class="text-right" v-if="info.parms && info.parms.exibir_valor_clinica">
                                        {{ 
                                            $util.formatMoeda(
                                                totalGeral(lista, 'valor_clinica')
                                                + totalGeral(lista, 'clinica_consumo')
                                            ) 
                                        }}
                                    </th>
                                    <!-- Exibir Valor Repassado e Saldo -->
                                    <template v-if="info.parms.exibir_repassado && info.parms.exibir_saldo_a_receber">
                                        <th class="text-right">{{ $util.formatMoeda(totalGeral(lista, 'repassado')) }}</th>
                                        <th class="text-right">{{ $util.formatMoeda(totalGeral(lista, 'valor_saldo_a_receber')) }}</th>
                                    </template>
                                    <th v-if="id_medico_repasse"></th>
                                </tr>
                                <template v-for="(atp, iax) in lista">
                                    <template v-if="exibir_expandido">
                                        <tr :key="igx + '-' + iax">
                                            <td>
                                                <a href="#" @click.prevent="abrir_atendimento(atp)" class="card-link">
                                                    #{{ atp.id_atendimento }}
                                                </a>
                                            </td>
                                            <td>
                                                {{ $util.getFormatDate(atp.dt_inicio).substr(0,5) }}
                                                <div v-if="info.parms.filtra_hora && atp.dt_inicio" class="text-muted">
                                                    {{ atp.dt_inicio.slice(11,16) }}
                                                </div>
                                            </td>
                                            <td>
                                                <span class="badge" :class="atp.origem == 'P' ? 'badge-secondary' : 
                                                    ( atp.origem == 'F' ? 'badge-primary' : 'badge-success' )">{{ atp.origem }}</span>
                                                <span v-if="atp.dt_ref">
                                                    {{ $util.getFormatDate(atp.dt_ref).substr(0,5) }}
                                                </span>
                                            </td>
                                            <td>
                                                <span v-if="atp.atendimento && atp.atendimento.paciente">{{ atp.atendimento.paciente.st_nome }}</span>
                                                <div class="text-muted small" v-if="atp.plano">
                                                    {{ atp.plano.search }}
                                                    <div v-if="atp.forma_pag_texto">
                                                        {{ atp.forma_pag_texto }}
                                                        <i class="fas fa-undo ml-1" v-if="atp.fp_devol"></i>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <span>
                                                    {{ atp.procedimento.search }}
                                                    <span v-if="atp.grau" class="text-muted ml-2">{{ atp.grau }}</span>
                                                </span>
                                                <span class="text-muted ml-2" title="Sessão">{{ atp.sessao }}</span>
                                                <span class="badge badge-secondary" v-if="atp.in_quantidade > 1" title="Quantidade">x{{ atp.in_quantidade }}</span>
                                                <span class="badge badge-warning" v-if="atp.nr" title="Recurso de Glosa">RG</span>
                                                <span class="badge badge-warning" v-if="atp.parcela" title="Parcela">{{ atp.parcela }}</span>
                                                <span v-if="atp.id_atendimento_procedimento_empacotado" title="Empacotado" class="ml-1">
                                                    <i class="fa-solid fa-box-archive"></i>
                                                </span>
                                                <span v-else-if="atp.id_atendimento_pacote" class="ml-1 d-print-none" title="Pacote">
                                                    <a href="#" @click.prevent="abrir_historico_pacotes(atp)">
                                                        <i class="fas fa-layer-group"></i>
                                                    </a>
                                                </span>
                                                <div v-if="atp.outro && atp.atendimento.medico" class="small text-muted">
                                                    {{ atp.atendimento.medico.search }}
                                                </div>
                                                <div v-if="atp.nao_finalizado" class="small text-muted">
                                                    Não finalizado
                                                </div>
                                            </td>
                                            <td>
                                                <a href="#" @click.prevent="ver_criterio(atp.id_rateio_medico)" class="card-link" v-if="!parms">
                                                    #{{ atp.id_rateio_medico }}
                                                </a>
                                                <span v-else>
                                                    #{{ atp.id_rateio_medico }}
                                                </span>
                                                <span class="ml-1" v-if="atp.devol" title="Devolução">
                                                    <i class="fas fa-undo"></i>
                                                </span>
                                                <a href="#" @click.prevent="editar_rateio(atp)" class="card-link mx-0 d-print-block" v-if="!parms">
                                                    <span class="ml-1" v-if="atp.especifico" title="Critério específico criado">
                                                        <i class="fas fa-edit fa-fw text-success"></i>
                                                    </span>
                                                    <span class="ml-1" v-if="!atp.especifico" title="Editar critério específico.">
                                                        <i class="fas fa-pen fa-fw"></i>
                                                    </span>
                                                </a>
                                                <i class="fas fa-archive fa-fw ml-1 text-muted" v-if="atp.empacotado" title="Empacotado"></i>
                                                <div class="text-muted small" v-if="!apuro.no_titulo_rateio && tipo_quebra != 'R'">
                                                    {{ atp.nome_rateio }}
                                                </div>
                                            </td>
                                            <td class="text-right" v-if="info && info.parms && info.parms.campos_exibir != 'R'">
                                                <span v-if="atp.cd_valor_total">
                                                    {{ $util.formatMoeda(atp.dc_valor_original) }}
                                                    <div class="small text-muted" v-if="false && atp.dc_valor_original && Math.round(atp.dc_valor_original * 100) != Math.round(atp.cd_valor_total * 100)">
                                                        {{ $util.formatMoeda(atp.dc_valor_original) }}
                                                    </div>
                                                </span>
                                            </td>
                                            <td class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">
                                                <span v-if="atp.valor_recebido">
                                                    {{ $util.formatMoeda(atp.valor_recebido) }}
                                                    <div class="small text-muted" v-if="false && atp.dc_valor_original != atp.valor_prod_total">de {{ $util.formatMoeda(atp.valor_prod_total) }}</div>
                                                </span>
                                            </td>
                                            <td class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">
                                                <span v-if="atp.valor_glosa || atp.valor_glosa === 0">
                                                    {{ $util.formatMoeda(atp.valor_glosa) }}
                                                </span>
                                                <div v-if="atp.taxa_cartao" title="Taxa do Cartão">
                                                    <span class="small text-muted">(Tx)</span> {{ $util.formatMoeda(atp.taxa_cartao) }}
                                                </div>
                                                <div v-if="atp.valor_filme" title="Valor do Filme">
                                                    <span class="small text-muted">(F)</span> {{ $util.formatMoeda(atp.valor_filme) }}
                                                </div>
                                                <div v-if="atp.valor_co" title="Valor do Custo Operacional">
                                                    <span class="small text-muted">(UCO)</span> {{ $util.formatMoeda(atp.valor_co) }}
                                                </div>
                                                <div v-if="atp.acatado" title="Valor Acatado" class="text-muted small">
                                                    <span>(A)</span> {{ $util.formatMoeda(atp.acatado) }}
                                                </div>
                                            </td>
                                            <td class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">
                                                {{ $util.formatMoeda(atp.valor_base) }}
                                                <div class="small text-muted" v-if="atp.perc && atp.perc != 0 && atp.rsr">
                                                    {{ $util.formatMoeda(atp.perc) }}%
                                                </div>
                                            </td>
                                            <td class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">
                                                <span v-if="atp.valor_retencao != 0 || atp.valor_cartao_pos != 0">
                                                    <template v-if="atp.valor_retencao">
                                                        {{ $util.formatMoeda(atp.valor_retencao * -1) }}
                                                        <div class="small text-muted">
                                                            {{ $util.formatMoeda(atp.perc_ret) }}%
                                                        </div>
                                                    </template>
                                                    <div class="small text-muted" v-if="atp.valor_cartao_pos">
                                                        TC: {{ $util.formatMoeda(atp.valor_cartao_pos * -1) }}
                                                    </div>
                                                </span>
                                            </td>
                                            <td class="text-right" :class="atp.nao_finalizado ? 'text-muted' : ''">
                                                <span v-if="atp.fl_pag_med" class="mr-1 text-muted" title="Valor recebido diretamento pelo médico.">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                        
                                                {{ $util.formatMoeda(atp.valor_base_rateio) }}
                                                <template v-if="info && info.parms && !info.parms.campos_exibir">
                                                    <div class="small text-muted" v-if="atp.perc && atp.perc != 0">
                                                        <template v-if="!atp.rsr">
                                                            {{ $util.formatMoeda(atp.perc) }}%
                                                        </template>
                                                    </div>
                                                    <div class="small text-muted" v-else-if="!atp.comissao">
                                                        v
                                                    </div>
                                                    <div class="small text-muted" v-if="atp.comissao > 0" title="Comissão">
                                                        C: {{ $util.formatMoeda(atp.comissao) }}
                                                    </div>
                                                </template>
                                            </td>
                                            <td class="text-right" v-if="info.parms && info.parms.exibir_valor_clinica"> 
                                                <div>
                                                    {{ $util.formatMoeda(atp.valor_clinica) }}
                                                </div>
                                                <div class="small text-muted" v-if="atp.valor_outros > 0" title="Outros Participantes">
                                                    OP: {{ $util.formatMoeda(atp.valor_outros * -1) }}
                                                </div>
                                            </td>

                                            <!-- Exibir Valor Repassado e Saldo -->
                                            <template v-if="info.parms.exibir_repassado && info.parms.exibir_saldo_a_receber">
                                                <td class="text-right">{{ $util.formatMoeda(atp.repassado) }}
                                                    <div class="small text-muted" v-if="atp.repassado > 0 && atp.info_repasse && atp.info_repasse.id_repasse" title="Repasse">
                                                        #{{ atp.info_repasse.id_repasse }}
                                                    </div>
                                                </td>
                                                <td class="text-right">{{ $util.formatMoeda(atp.valor_saldo_a_receber) }}</td>
                                            </template>

                                            <td class="text-center" v-if="id_medico_repasse || exibe_selecao">
                                                <input type="checkbox" v-model="atp.selecionado" :disabled="atp.nao_finalizado">
                                            </td>
                                        </tr>

                                        <template v-if="atp.detalhe_consumo && atp.detalhe_consumo.length">
                                            <tr v-for="(consumo, icx) in atp.detalhe_consumo" :key="'C' + igx + iax + '.' + icx">
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>
                                                    {{ consumo.search }}
                                                    <span class="badge badge-secondary" v-if="consumo.qtd > 1">
                                                        x{{ consumo.qtd }}
                                                    </span>
                                                    <div v-if="exibe_pue && consumo.info_pue && ( consumo.info_pue.valor || consumo.info_pue.retencao_tit )" class="text-muted small">
                                                        <div v-if="consumo.info_pue.valor">
                                                            PUE: {{ $util.formatMoeda(consumo.info_pue.valor, 6, 2) }} 
                                                            <span v-if="consumo.qtd > 1">
                                                                x {{ consumo.qtd }} = {{ $util.formatMoeda(consumo.info_pue.valor * consumo.qtd) }}
                                                            </span>
                                                            <span v-if="consumo.info_pue.lucro">
                                                                (L)
                                                            </span>
                                                            <span v-if="consumo.info_pue.idm">
                                                                (M{{ consumo.info_pue.idm }})
                                                            </span>
                                                        </div>

                                                        <div v-if="consumo.info_pue.retencao_tit">
                                                            {{ consumo.info_pue.retencao_tit }}: {{ $util.formatMoeda(consumo.info_pue.retencao_pue) }}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td></td>
                                                <td class="text-right" v-if="info && info.parms && info.parms.campos_exibir != 'R'">{{ $util.formatMoeda(consumo.total) }}</td>
                                                <td class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">
                                                    <span v-if="consumo.recebido !== null">{{ $util.formatMoeda(consumo.recebido) }}</span>
                                                </td>
                                                <td class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">
                                                    <span v-if="consumo.glosa !== null">{{ $util.formatMoeda(consumo.glosa) }}</span>
                                                    <div v-if="consumo.taxa_cartao" title="Taxa do Cartão">
                                                        <span class="small text-muted">(Tx)</span> {{ $util.formatMoeda(consumo.taxa_cartao) }}
                                                    </div>
                                                </td>
                                                <td class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">
                                                    {{ $util.formatMoeda(consumo.base) }}
                                                    <div class="small text-muted" v-if="consumo.perc && consumo.perc && consumo.rsr">
                                                        {{ $util.formatMoeda(consumo.perc) }}%
                                                    </div>
                                                </td>
                                                <td class="text-right" v-if="info && info.parms && !info.parms.campos_exibir">
                                                    <div v-if="consumo.retencao">
                                                        {{ $util.formatMoeda(consumo.retencao * -1) }}
                                                    </div>
                                                    <div class="small text-muted" v-if="consumo.perc_ret">
                                                        {{ $util.formatMoeda(consumo.perc_ret) }}%
                                                    </div>
                                                    <div class="small text-muted" v-if="consumo.valor_cartao_pos">
                                                        TC: {{ $util.formatMoeda(consumo.valor_cartao_pos * -1) }}
                                                    </div>
                                                </td>
                                                <td class="text-right">
                                                    {{ $util.formatMoeda(consumo.rateio) }}
                                                    <template v-if="info && info.parms && !info.parms.campos_exibir">
                                                        <span v-if="consumo.perc && !consumo.rsr">
                                                            <div class="small text-muted">
                                                                {{ $util.formatMoeda(consumo.perc) }}%
                                                            </div>
                                                        </span>
                                                    </template>
                                                </td>
                                                <td class="text-right" v-if="info.parms && info.parms.exibir_valor_clinica">
                                                    {{ $util.formatMoeda(consumo.valor_clinica) }}
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                </template>
                            </template>
                        </tbody>
                    </table>

                </div>

                <div class="d-flex" v-if="!resumo_pagamento">
                    <az-submit class="mr-2"  @click="compor()" v-if="selecionados.length && id_medico_repasse">Compor</az-submit>
                    <az-submit color="outline-primary mr-2" @click="selecionar_apuracao()" v-if="selecionados.length && !parms">Buscar</az-submit>
                    <print-export printid="impressao" :dados="dados_exportacao" />
                </div>

                <pre v-if="false" class="alert alert-info">{{ lista_agrupada }}</pre>

            </template>

            <template v-else>

                <az-empty-state 
                    msg="Nenhum lançamento relacionado" 
                    action="Apurar Produção" 
                    :method="selecionar_apuracao"/>

            </template>

        </div>

        <!-- Modal -->
        <div class="modal fade" :id="mult ? 'apuracaoModalMult' : 'apuracaoModal'" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="tipos">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ dre ? 'Previsão de Repasse (DRE)' : ( mult ? 'Compor Repasse' : 'Apurar Produção' ) }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="simulacao">
                            <div class="row">
                                <div class="col col-12 d-flex flex-column">
                                    <az-input
                                        type="button-group"
                                        :optionsList="[
                                            { id: 'P', search: 'Período' }, 
                                            { id: 'I', search: 'Id do Atendimento' }, 
                                        ]"
                                        v-model="apuro.tipo_filtro" />
                                </div>    
                            </div>
                        </template>

                        <template v-if="apuro.tipo_filtro == 'I'">
                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="number"
                                        label="Id do Atendimento"
                                        placeholder="..."
                                        v-model="apuro.id_atendimento" />
                                </div>
                            </div>
                        </template>

                        <template v-else>

                            <template v-if="( apuro.produzido ) && ( ( mult && corte_faturamento ) || ( !mult && medico_repasse && medico_repasse.corte_faturamento ) )">
                                <div class="row">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            type="date"
                                            label="Produção De"
                                            :edicao="!dre"
                                            v-model="apuro.inicio" />
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            type="date"
                                            label="Produção Até"
                                            :edicao="!dre"
                                            v-model="apuro.fim" />
                                    </div>
                                </div>

                                <div class="row" v-if="!dre">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            type="date"
                                            label="Faturado De"
                                            v-model="apuro.fat_inicio" />
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            type="date"
                                            label="Faturado Até"
                                            required
                                            :validate="validate"
                                            v-model="apuro.fat_fim" />
                                    </div>
                                </div>
                            </template>

                            <template v-else>
                                <div class="row">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            type="date"
                                            label="De"
                                            v-model="apuro.inicio" />
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            type="date"
                                            label="Até"
                                            v-model="apuro.fim" />
                                    </div>
                                </div>
                            </template>

                            <template v-if="1==1">
                                <div class="row mt-3">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Filtrar pela Hora do Atendimento"
                                            v-model="apuro.filtra_hora" />
                                    </div>
                                    <template v-if="apuro.filtra_hora">
                                        <div class="col col-12 col-md-3">
                                            <az-input
                                                sizing="sm"
                                                icon="fa-solid fa-greater-than-equal fa-fw"
                                                type="time"
                                                required
                                                :validate="validate"
                                                v-model="apuro.hor_inicio" />
                                        </div>
                                        <div class="col col-12 col-md-3">
                                            <az-input
                                                sizing="sm"
                                                icon="fa-solid fa-less-than-equal fa-fw"
                                                type="time"
                                                required
                                                :validate="validate"
                                                v-model="apuro.hor_fim" />
                                        </div>
                                    </template>
                                </div>
                            </template>

                            <!-- Filtro pelo Atendimento, no repasse pelo recebido -->
                            <div class="row" v-if="( !apuro.produzido || ( tipos && !tipos.P ) )  
                                    && ( !apuro.faturado || ( tipos && !tipos.F ) )  
                                    && apuro.recebido">

                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="date"
                                        label="Atendido de"
                                        v-model="apuro.atd_inicio" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="date"
                                        label="Atendido até"
                                        v-model="apuro.atd_fim" />
                                </div>
                                
                            </div>

                        </template>

                        <template v-if="origem != 'P'">
                        
                            <az-sub-title class="mt-3" title="Incluir rateios..." />

                            <az-input
                                :edicao="( !tipos || tipos.P ) ? true : false"
                                sizing="sm"
                                type="checkbox-group"
                                label="por produção"
                                v-model="apuro.produzido" />

                            <az-input
                                :edicao="( !tipos || tipos.F ) ? true : false"
                                sizing="sm"
                                type="checkbox-group"
                                label="por faturamento / pagamento"
                                v-model="apuro.faturado" />

                            <az-input
                                :edicao="( !tipos || tipos.R ) ? true : false"
                                sizing="sm"
                                type="checkbox-group"
                                label="por recebimento"
                                v-model="apuro.recebido" />

                        </template>

                        <div v-if="simulacao">

                            <az-sub-title class="mt-3" title="Opções" />

                            <az-input
                                sizing="sm"
                                type="checkbox-group"
                                label="Não exibir descrição da regra de rateio"
                                v-model="apuro.no_titulo_rateio" />

                            <az-input
                                sizing="sm"
                                type="checkbox-group"
                                label="Não abater regra de devoluções"
                                v-model="apuro.no_devol" />

                            <az-input
                                sizing="sm"
                                type="checkbox-group"
                                label="Exibir valor da clínica"
                                v-model="apuro.exibir_valor_clinica" />

                            <az-input
                                sizing="sm"
                                type="checkbox-group"
                                label="Deduzir retenção do valor da clínica"
                                v-if="apuro.exibir_valor_clinica"
                                v-model="apuro.deduzir_imposto_clinica" />

                            <az-input
                                sizing="sm"
                                type="checkbox-group"
                                label="Exibir valor mesmo sem repasse"
                                v-if="apuro.exibir_valor_clinica && ( origem == 'P' || 1==1 )"
                                v-model="apuro.completo" />

                            <az-input
                                sizing="sm"
                                type="checkbox-group"
                                label="Exibir mesmo se já repassado"
                                v-if="1==1 || origem == 'P' || ( $store.state.user.id_usuario == 1 )"
                                v-model="apuro.exibir_repassado" />

                            <az-input
                                sizing="sm"
                                type="checkbox-group"
                                label="Exibir valor do PUE (Preço da Última Entrada), quando aplicável"
                                v-if="1==1 || origem == 'P' || ( $store.state.user.id_usuario == 1 )"
                                v-model="exibe_pue" />

                            <az-input
                                sizing="sm"
                                type="checkbox-group"
                                label="Exibir saldo a receber"
                                v-if="origem == 'P' && apuro.exibir_repassado"
                                v-model="apuro.exibir_saldo_a_receber" />

                            <az-input 
                                sizing="sm"
                                class="mt-3"
                                placeholder="Exibir Campos Detalhados"
                                type="select" 
                                :optionsList="[
                                    { id: 'R', search: 'Exibir Apenas o Valor de Repasse' },
                                    { id: 'P', search: 'Exibir Apenas o Valor de Produzido e o Repasse' },
                                ]"
                                optionsData="id"
                                v-model="apuro.campos_exibir" />
                        </div>

                        <template v-if="!dre">
                            <filtro-model class="mt-3" v-model="apuro.filtros" :delecao="true" :validate="validate" :opcoes="lista_opcoes_filtro" />
                            <br><br><br><br><br><br>
                        </template>

                        <pre v-if="false">{{ tipos }}</pre>
                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="buscar_apuracao()">{{ ( !dre && mult ) ? 'Compor' : 'Apurar' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-rateio-medico ref="cadrateio_ap" modalname="apuracao" :viewonly="true" @refresh="buscar_apuracao()" v-if="!parms" />

        <historico-pacotes-paciente-modal 
            :viewonly="true"
            ref="historico_pacotes" 
            :paciente="info_pacote ? info_pacote.paciente : null"
            :id_atendimento="info_pacote ? info_pacote.id_atendimento : null" />
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import FiltroModel from '../../cadastros/shared/FiltroModel.vue';
import EdicaoRateioMedico from '../../cadastros/shared/EdicaoRateioMedico.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import HistoricoPacotesPacienteModal from '../../shared/HistoricoPacotesPacienteModal.vue';

export default {
    data() { 
        return { 
            apuracao: null, 
            search_apuracao: "", 
            apuro: { 
                inicio: "",
                fim: "",
                produzido: true,
                faturado: true,
                recebido: true,
                filtros: [], 
                atd_inicio: "",
                atd_fim: "", 
                origem: "",
                exibir_repassado: false, 
                exibir_valor_clinica: false, 
                exibir_saldo_a_receber: false, 
                campos_exibir: "", 
                completo: false, 
                tipo_filtro: 'P', 
                filtra_hora: false,
                hor_inicio: "",
                hor_fim: "", 
            },
            validate: false, 
            info: null, 
            tipos: null, 
            tipo_quebra: 'N',
            expandido: true, 
            corte_faturamento: false, 
            filtro_repassado: 'T', 
            info_pacote: null, 
            exibe_selecao: false, 
            id_rateio_troca: null, 
            exibe_pue: false, 
            funcao_pesq: 'F', 
            search_selecao: "", 
        }
    },

    components: { 
        AzInput,
        AzSubmit,
        AzEmptyState,
        AzSubTitle, 
        EdicaoRateioMedico, 
        FiltroModel, 
        PrintExport,
        CabecalhoGenerico,  
        HistoricoPacotesPacienteModal, 
    },

    props: [
        'id_medico', 'id_medico_repasse', 'medico_repasse', 'item', 'origem', 'simulacao',
        'mult', 'direto_medico', 'parms', 'na_recepcao', 'exibir_saldo', 'resumo_pagamento',
        'callback_apuracao', 'dre', 
    ],

    computed: { 
        lista_quebras: function () { 

            let lista = [
                { id: 'N', search: ( ( this.info && this.info.geral ) ? 'Profissional' : 'Sem Quebra' ), quebra: ( ( this.info && this.info.geral ) ? this.id_medico : '' ) }, 
                { id: 'O', search: 'Operadora', quebra: 'plano.operadora.search' }, 
                { id: 'R', search: 'Regra de Repasse', quebra: 'nome_rateio' }, 
                { id: 'P', search: 'Procedimento', quebra: 'procedimento' }, 
                { id: 'F', search: 'Forma de Pag.', quebra: 'forma_pag' }, 
            ];

            //if ( this.info.parms && this.info.parms.origem == 'P' ) { 
                lista.push({ id: 'U', search: 'Unidade', quebra: 'unidade_operacao.st_nome' });
            //}

            return lista;

        },

        exibir_expandido: function () { 
            return ( this.tipo_quebra == 'N' && ( !this.info || !this.info.geral ) ) || this.expandido;
        },

        todos_marcacao: { 
            get() {
                if ( !this.apuracao )
                    return false;

                return this.apuracao.findIndex(atp => !atp.selecionado) < 0;
            },
            set(value) {
                this.apuracao.forEach(element => {
                    if ( !element.nao_finalizado ) { 
                        element.selecionado = value;
                    }
                });
            }
        },
        
        lista_agrupada: function () { 
            if ( this.tipo_quebra == 'N' && ( !this.info || !this.info.geral ) ) { 
                return { 
                    todos: this.lista_apuracao
                };
            }

            let quebra = 'nenhuma';

            switch (this.tipo_quebra) {
                case 'O':
                    quebra = 'plano.operadora.search';
                    break;

                case 'U':
                    quebra = 'unidade_operacao.st_nome';
                    break;

                case 'R':
                    quebra = (item) => { 
                        let outro = _.get(item, 'rat_outro_titulo');

                        return _.get(item, 'nome_rateio') 
                            + ( outro ? ' / ' + outro : '' );   
                    };
                    break;

                case 'F':
                    quebra = (item) => { 
                        let forma = _.get(item, 'forma_pag_texto');

                        return forma ? forma : '-';
                    };
                    break;

                case 'P':
                    quebra = 'procedimento.search';
                    break;

                case 'N':
                    if ( this.info && this.info.geral ) { 
                        quebra = 'nm';
                    }
                    break;
            }

            return _.groupBy(
                _.orderBy(
                    this.lista_apuracao,
                    quebra
                ), 
                quebra
            );
        },

        lista_apuracao: function () { 
            if ( !this.apuracao )
                return [];

            let pesquisar = this.funcao_pesq == 'L' ? '' : this.search_apuracao.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.apuracao.filter (item => ( !this.search_apuracao || reg.test(JSON.stringify(item)) ))
                .filter(item => this.filtro_repassado == 'T' 
                    || ( this.filtro_repassado == 'S' && item.valor_saldo_a_receber ) 
                    || ( this.filtro_repassado == 'N' && !item.valor_saldo_a_receber )
                );
        },

        selecionados: function () { 
            if ( !this.apuracao )
                return [];

            return this.lista_apuracao.filter(item => item.selecionado);
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\formaPagamento', search:'Forma de Pagamento', service: 'forma_pagamentos.index', nosync: true},
                {id:'App\\azure\\recepcao', search:'Recepção', service: 'recepcaos.index', parms: { filtros: true }},
                // {id:'App\\azure\\fatura', search:'Fatura', service: 'faturas.index'},
            ];

            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade', service: 'unidade_operacaos.index'});
            }
            
            return opcoes;
        },

        dados_exportacao: function () { 
            if ( this.direto_medico )
                return null;

            if ( !this.lista_apuracao ) { 
                return [];
            }

            return this.lista_apuracao.flatMap(item => { 

                console.log('itemrr', item);

                let linha = { 
                    id_atendimento: item.id_atendimento, 
                    data: this.$util.getFormatDate(item.dt_inicio), 
                    tipo: item.origem,
                    referencia: ( item.dt_ref ? this.$util.getFormatDate(item.dt_ref) : '' ), 
                    paciente: ( item.atendimento && item.atendimento.paciente ) ? item.atendimento.paciente.st_nome : '?',
                    plano: item.plano ? item.plano.search : '?',
                    procedimento: item.procedimento.search,
                    grau: item.grau ? item.grau : _.get(item, 'grauParticipacao.st_grau_participacao'),
                    regra: item.id_rateio_medico, 
                    devolucao: item.devol ? 'S' : 'N', 
                    produzido: this.$util.formatMoeda(item.dc_valor_original),
                    recebido: this.$util.formatMoeda(item.valor_recebido ? item.valor_recebido : 0),
                    glosa_desc: this.$util.formatMoeda(item.valor_glosa ? item.valor_glosa : 0),
                    taxa_cartao: this.$util.formatMoeda(( item.taxa_cartao ? item.taxa_cartao : 0) + ( item.valor_cartao_pos ? item.valor_cartao_pos : 0)), 
                    filme: this.$util.formatMoeda(item.valor_filme ? item.valor_filme : 0),
                    custo_oper: this.$util.formatMoeda(item.valor_co ? item.valor_co : 0),
                    valor: this.$util.formatMoeda(item.valor_base),
                    imposto: this.$util.formatMoeda(item.valor_retencao),
                    repasse: this.$util.formatMoeda(item.valor_base_rateio), 
                    prof: item.nm ? item.nm : '', 
                    forma_pag: item.forma_pag_texto ? item.forma_pag_texto : '',
                    parcelas: item.parcela ? "'" + item.parcela : '',
                };

                if ( this.info && this.info.parms && this.info.parms.exibir_repassado && this.info.parms.exibir_saldo_a_receber ) { 
                    linha.repassado = this.$util.formatMoeda(item.repassado);
                    linha.saldo_a_receber = this.$util.formatMoeda(item.valor_saldo_a_receber);
                }

                let lista = [linha];

                if ( item.detalhe_consumo && item.detalhe_consumo.length ) { 
                    item.detalhe_consumo.forEach(dc => { 
                        lista.push({
                            id_atendimento: item.id_atendimento, 
                            data: this.$util.getFormatDate(item.dt_inicio), 
                            tipo: item.origem,
                            referencia: ( item.dt_ref ? this.$util.getFormatDate(item.dt_ref) : '' ), 
                            paciente: ( item.atendimento && item.atendimento.paciente ) ? item.atendimento.paciente.st_nome : '?',
                            plano: item.plano ? item.plano.search : '?',
                            procedimento: dc.search,
                            grau: item.grau,
                            regra: item.id_rateio_medico, 
                            devolucao: item.devol ? 'S' : 'N', 
                            produzido: this.$util.formatMoeda(dc.total),
                            recebido: this.$util.formatMoeda(dc.recebido),
                            glosa_desc: this.$util.formatMoeda(dc.glosa),
                            taxa_cartao: this.$util.formatMoeda(dc.taxa_cartao), 
                            filme: this.$util.formatMoeda(0),
                            custo_oper: this.$util.formatMoeda(0),
                            valor: this.$util.formatMoeda(dc.base),
                            imposto: this.$util.formatMoeda(dc.retencao),
                            repasse: this.$util.formatMoeda(dc.rateio), 
                            prof: item.nm ? item.nm : '',
                            forma_pag: item.forma_pag_texto ? item.forma_pag_texto : '',
                            parcelas: item.parcela ? "'" + item.parcela : '',
                        });
                    });

                }

                return lista;


            });
        }
    },

    methods: { 
        selecionar_atend () { 
            if ( !this.search_selecao ) { 
                return; 
            }

            // Obter números da string de pesquisa
            let numeros = this.search_selecao.match(/\d+/g);
            let encontrado = false; 
            let marcado = false; 

            this.lista_apuracao.forEach(item => { 
                if ( item.id_atendimento == numeros ) { 
                    if ( !item.selecionado ) { 
                        marcado = true; 
                    }
                    item.selecionado = true;     
                    encontrado = true; 
                }
            });

            if ( !encontrado ) { 
                this.$toast.add({ 
                    severity: 'warn', 
                    summary: 'Atenção', 
                    detail: 'Atendimento não encontrado: ' + this.search_selecao, 
                    life: 3000
                });
            } else if ( !marcado ) { 
                this.$toast.add({ 
                    severity: 'info', 
                    summary: 'Atenção', 
                    detail: 'Atendimento já selecionado: ' + this.search_selecao, 
                    life: 3000 
                });
            } else { 
                this.$toast.add({ 
                    severity: 'success', 
                    summary: 'Atenção', 
                    detail: 'Atendimento selecionado: ' + this.search_selecao, 
                    life: 3000 
                });
            }

            this.search_selecao = '';

            
        },

        alterar_rateio_medico () { 

            if ( !confirm ('Confirma alterar o rateio médico dos itens selecionados?') ) { 
                return; 
            }

            let lista = this.lista_apuracao.filter(item => item.selecionado && item.id_rateio_medico != this.id_rateio_troca)
                .filter(item => item.id_atendimento_procedimento && !item.id_atendimento_procedimento_equipe)
                .map(item => item.id_atendimento_procedimento);

            this.$util.atualizar(this, { 
                service: 'repasses', 
                func: 'alterar_rateio_medico',
                dados: { 
                    lista: lista, 
                    id_rateio_destino: this.id_rateio_troca,
                },
                callback: () => { 
                    this.buscar_apuracao();
                }
            });

        },

        abrir_selecao_n_proc () { 

            let agrupado = _.groupBy(
                _.orderBy(this.lista_apuracao, 'valor_base_rateio', 'asc'),
                'id_atendimento'
            );
            
            console.log('agrupado', agrupado);

            _.each(agrupado, (itens) => { 

                let qtd = itens.length >= 5 ? 3 : 2; 

                itens.forEach(item => { 
                    if ( qtd ) { 
                        qtd --;
                        item.selecionado = false;
                    }
                });
            });

        },

        abrir_historico_pacotes (atp) { 
            this.info_pacote = { 
                paciente: atp.atendimento.paciente, 
                id_atendimento: atp.id_atendimento,
            };

            this.$refs.historico_pacotes.abrir(this.info_pacote.paciente.id_pessoa);
        },

        editar_rateio (atp) { 
            this.$refs.cadrateio_ap.editar(
                atp.id_rateio_medico, 
                true, 
                atp.id_atendimento_procedimento,
                atp.id_atendimento_procedimento_equipe 
            );
        },

        titulo_model (filtro) { 
            let model = this.lista_opcoes_filtro.find(op => op.id == filtro.model_type);
            return model ? model.search : '?';
        },

        abrir_atendimento (atp) { 
            this.$util.abrir_atendimento(this, atp.id_atendimento);
        },

        totalGeral(lista, campo, selecioando = false, campo_unico = null) { 
            if ( !lista )
                return 0;

            if ( campo_unico ) { 
                lista = _.uniqBy(lista, campo_unico);
            }
            
            return lista.reduce((total, carry) => { 
                return total + ( 
                        ( selecioando && !carry.selecionado ) 
                            ? 0 
                            : ( ( carry[campo] && !isNaN(carry[campo]) ) ? carry[campo] : 0 ) 
                    );
            }, 0);
        },

        ver_criterio(id_rateio_medico) { 
            this.$refs.cadrateio_ap.editar(id_rateio_medico);
        },

        selecionar_apuracao() { 
            if ( this.item ) { 
                this.apuro.inicio = this.item.dt_inicio;
                this.apuro.fim = this.item.dt_termino;    
            } else if ( !this.apuro.inicio ) { 
                this.apuro.inicio = this.$util.hoje();
                this.apuro.fim = this.$util.hoje();
            }

            this.apuro.origem = this.origem;

            this.apuracao = null;
            this.validate = false;
            this.tipos = null;

            this.$nextTick(() => { 

                if ( !this.mult ) { 

                    this.$util.load(this, { 
                        service: 'rateio_medicos',
                        func: 'tipos',
                        parms: { 
                            id_medico_repasse: this.id_medico_repasse, 
                            id_medico: this.id_medico, 
                        },
                        loadTo: res => { 
                            this.tipos = res; 

                            if ( this.parms ) { 
                                this.buscar_apuracao();
                            } else { 
                                $('#apuracaoModal').modal('show');
                            }
                        }
                    });

                } else { 

                    this.tipos = { 
                        P: true,
                        F: true, 
                        R: true, 
                    };

                    this.$util.load(this, { 
                        service: 'configuracoes',
                        func: 'index',
                        parms: { 
                            where: {
                                st_slug: 'repasse-corte-faturamento',
                                fl_ativo: '1',
                            }
                        },
                        loadTo: res => { 
                            if ( res.length ) { 
                                this.corte_faturamento = true;
                            }
                            
                            $('#apuracaoModalMult').modal('show');
                        }
                    });

                }

            });
        },

        buscar_apuracao(append = false) { 
            this.expandido = this.callback_apuracao ? false : true;

            if ( !append ) { 
                this.apuracao = null;
                this.info = null;
            }

            let apuro = _.cloneDeep(this.apuro);

            if ( this.parms ) { 
                _.each(this.parms, (value, parm) => { 
                    apuro[parm] = value;
                });
            }

            this.$util.setCookie('rp-apr-origem', apuro.origem == 'P' ? 'P' : 'R');
            this.$util.setCookie('rp-e-pue', this.exibe_pue ? 'S' : 'N');
            
            let apurar_consumo = true;

            if ( this.tipos ) { 

                if ( !this.tipos.P ) { 
                    apuro.produzido = false;
                }

                if ( !this.tipos.F ) { 
                    apuro.faturado = false;
                }

                if ( !this.tipos.R ) { 
                    apuro.recebido = false;
                }

                apurar_consumo = ( this.tipos.CONSUMO === false ) ? false : true;

            }

            if ( this.mult ) { 
                this.$emit('compor', { 
                    ...apuro, 
                    apurar_consumo: apurar_consumo, 
                });

                $('.modal').modal('hide');

                return; 
            }

            this.$util.load(this, { 
                service: 'repasses',
                func: this.direto_medico ? 'apuracao_logado' : 'apuracao',
                redir_api: true,
                parms: { 
                    id_medico_repasse: this.id_medico_repasse, 
                    id_medico: this.id_medico, 
                    ...apuro, 
                    apurar_consumo: apurar_consumo, 
                    simulacao: this.simulacao, 
                    direto_medico: this.direto_medico,
                    na_recepcao: this.na_recepcao,  
                },
                configs: [
                    'repasse-apuracao-id-rateio-troca', 
                ],
                loadTo: res => {

                    if ( this.$store.state.contexto['repasse-apuracao-id-rateio-troca'] ) { 
                        this.id_rateio_troca = this.$store.state.contexto['repasse-apuracao-id-rateio-troca'];
                    }

                    this.info = { 
                        medico: res.medico,
                        parms: res.parms, 
                        geral: this.callback_apuracao ? true : false, 
                    };
                    
                    if ( this.callback_apuracao ) { 
                        
                        if ( !this.apuracao ) { 
                            this.apuracao = res.apuracao.map(item => { 
                                item.nm = res.medico.st_nome_exibicao;
                                return item;
                            });  
                        } else { 
                            this.apuracao = this.apuracao.concat(
                                res.apuracao.map(item => { 
                                    item.nm = res.medico.st_nome_exibicao;
                                    return item;
                                })
                            );  
                        }

                        this.callback_apuracao(res);

                    } else { 

                        this.apuracao = res.apuracao;  
                        
                    }
                    
                    $('#apuracaoModal').modal('hide');
                },
            });
        },

        compor () { 
            this.$emit('compor', this.selecionados);

            this.$nextTick(() => { 
                this.apuracao = null;
                this.info = null;
            });
        }
    },

    beforeMount() { 
        this.exibe_pue = this.$util.getCookie('rp-e-pue') == 'S' ? true : false;
    },

    mounted() { 
        if ( this.direto_medico ) { 
            this.apuro.exibir_repassado = true;
            this.apuro.exibir_saldo_a_receber = this.exibir_saldo ? true : false;
        }
    }
}
</script>